import React, { useCallback, useState } from "react";
import { Button, Classes } from "@blueprintjs/core";
import { useMutation, useQueryClient } from "react-query";
// import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/tasks-query'
import { taskEventMutation } from "ui-io/queries/tasks/task-event-mutation";
import { Box, InlineSpinnerIcon, ThemedDialog } from "ui-components";
import { delay } from "ui-lib/delay";
import { TaskT } from "ui-io/task-io/task-t";
// import { useSessionState } from '@maps-internal/neutron-react-client'
import useSession from "ui-io/use-session";
import { useNavigate } from "react-router-dom";

import toasts from "../../utils/toasts";
import { TASKS_QUERY_FILTER } from "ui-io/queries/tasks/task-query";
import { TASKS_SEARCH_QUERY } from "ui-io/queries/tasks/tasks-query";
import { formatLocation } from "../../routes";

const PublishSubmissionButton = ({
  task,
  // testRunStatus,
}: {
  task: TaskT;
  // testRunStatus?: string | null;
}) => {
  const { isReadyForPublish, assignee } = task;
  const { session } = useSession();
  const username = session?.username || "";
  const userRole = session?.role || "";
  const isInReview = isReadyForPublish;
  const history = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async function ({ task }: { task: TaskT }) {
      // if (task?.lastTestRun?.status !== "success") {
      //   throw new Error(
      //     `Last test run should be successful in order to approve the task.`
      //   );
      // }
      if (task.isReadyForPublish) {
        return await taskEventMutation({
          taskId: task.id,
          eventType: "FINISH_PUBLICATION",
          updatedBy: username,
        });
      } else {
        throw new Error(
          `Cannot approve submission for task in state "${task.state}"`
        );
      }
    },
    {
      onError: (error) => {
        console.error(error);
        toasts.error(`Encountered an error when approving a submission`);
      },
      onSuccess: async () => {
        toasts.success(`Successfully Publihed data to dashboard`);
        await delay(500);
        queryClient.refetchQueries([TASKS_QUERY_FILTER]);
        queryClient.refetchQueries([TASKS_SEARCH_QUERY]);
        history(formatLocation.taskPeerReview({}));
      },
    }
  );

  const disabled = !isInReview || mutation.isLoading;

  const handleRequestNewTaskButtonClick = useCallback(async () => {
    if (disabled) {
      return;
    }
    await mutation.mutateAsync({
      task,
    });
    setIsOpen(false);
  }, [disabled, mutation, task]);

  // if (!isInProgress || (username !== assignee && !task.isReadyForPublish)) {
  if (!isInReview || (username == assignee && userRole != "SUPER_ADMIN")) {
    return null;
  }
  return (
    <>
      <Button
        icon="tick"
        onClick={() => {
          setIsOpen(true);
        }}
        disabled={disabled}
        intent="success"
      >
        {mutation.isLoading ? (
          <>
            Publishing
            <Box mx="small" inline>
              <InlineSpinnerIcon />
            </Box>
          </>
        ) : (
          "Publish"
        )}
      </Button>

      <ThemedDialog
        isOpen={isOpen}
        title="Publish task"
        onClose={() => setIsOpen(false)}
        icon="delete"
      >
        <div className={Classes.DIALOG_BODY}>
          {/* {task.tags?.includes("MENU_TASK") && */}
          Task will be published to Dashboard. Are you sure?
          {/* } */}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={() => setIsOpen(false)}>Cancel</Button>
            <Button intent="primary" onClick={handleRequestNewTaskButtonClick}>
              Confirm
            </Button>
          </div>
        </div>
      </ThemedDialog>
    </>
  );
};

export default PublishSubmissionButton;
